import React from 'react'
import ButtonCardWrapper, { RadioButtonContent, useIsSelected } from './ButtonCardWrapper'
import { ButtonCardProps, ButtonContentProps } from './buttonCardProps'

/**
 * Use this component to allow the user select/unselect an Item normally presented
 * in a list of choices (Use SelectableCardGrid component to build a list of options).
 * The main difference with the CheckboxButtonCard is that there is no check icon
 * presented to be able to make the distinction between multiple select and single select mode.
 *
 * This component is presented in a Card styling
 *
 * @param props - {@link ButtonCardProps}
 *
 * @example \<RadioButtonCard logo=\{\<FontAwesomeIcon icon=\{['fas', 'check']\} /\>\} title='Upper Line' description='Lower Line' /\>
 */
const RadioButtonCard = React.forwardRef<HTMLDivElement, ButtonCardProps & ButtonContentProps>(
  ({ isSelected, disabled, initialSelected, onClick, className, children, ...buttonContentProps }, ref) => {
    const [selected, toggleSelected] = useIsSelected({ initialSelected, controlledSelected: isSelected })

    const handleOnClick: ButtonCardProps['onClick'] = (e) => {
      toggleSelected()
      if (onClick) {
        onClick(e)
      }
    }

    return (
      <ButtonCardWrapper
        ref={ref}
        isSelected={selected}
        disabled={disabled}
        onClick={handleOnClick}
        className={className}
        role="radio"
      >
        <RadioButtonContent {...buttonContentProps}>{children}</RadioButtonContent>
      </ButtonCardWrapper>
    )
  }
)
RadioButtonCard.displayName = 'RadioButtonCard'

export default RadioButtonCard
